
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g8Fnr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e5659dc7f777b09f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $e5659dc7f777b09f$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Pagina senza titolo',
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Crea una nuova pagina e inseriscila come link',
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Crea pagina Confluence',
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Apri in Confluence',
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "La tua pagina \xe8 stata creata",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Pagina creata',
    'editorExtensionLinkCreate.confluencePage.title': 'Crea nuova pagina',
    'editorExtensionLinkCreate.genericError.description': 'Aggiorna la pagina e riprova.',
    'editorExtensionLinkCreate.genericError.title': "Si \xe8 verificato un problema",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Crea un ticket in linea e inserisci il ticket come link',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Crea ticket Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Apri in Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "Il tuo ticket \xe8 stato creato",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Ticket creato',
    'editorExtensionLinkCreate.jiraIssue.title': 'Crea nuovo ticket',
    'editorExtensionLinkCreate.keyword.create': 'crea',
    'editorExtensionLinkCreate.keyword.issue': 'ticket',
    'editorExtensionLinkCreate.keyword.new': 'nuovo',
    'editorExtensionLinkCreate.keyword.page': 'pagina',
    'editorExtensionLinkCreate.keyword.publish': 'pubblica',
    'editorExtensionLinkCreate.keyword.raise': 'segnala',
    'editorExtensionLinkCreate.keyword.space': 'spazio',
    'editorExtensionLinkCreate.keyword.ticket': 'ticket'
};

});


//# sourceMappingURL=it.3c30e21d.js.map
